<template>
  <div>
    <audio id="audio" :src="music.src" preload="auto" style="display: none;"></audio>
    <FooterPlayer @clickMethod="expandPlayer()"/>
    <v-dialog
      v-model="playerDialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay=false
      scrollable
    >
      <div class="music-player">
        <v-toolbar class="music-player__tool-bar" flat>
          <v-btn icon @click.native="playerDialog = false" class="music-player__close-btn">
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="music-player__content">
          <v-layout row justify-center @click="showLyric()" class="music-player-information-upper">
            <v-flex xs12 md6 >
              <div class="music-player-information-upper__title-container">
                <div class="music-player-tune-title">
                  <MarqueeMessage
                    ref="upperMarqueeMessageTitle"
                    :message="music.title"
                    parent="player-upper"/>
                </div>
                <div class="music-player-tune-artist">
                  <MarqueeMessage
                    ref="upperMarqueeMessageArtist"
                    :message="music.artist"
                    parent="player-upper"/>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md6 v-if="music.lyrics"></v-flex>
          </v-layout>
          <v-layout row justify-center class="music-player__tune-media" @click="showLyric()">
            <v-flex xs12 md6 style="text-align: center" class="music-player__image-container">
              <img v-if="music.artistImage"
                   :src="music.artistImage"
                   class="music-player__tune-image"
                   :class="{'--blur': isShowLyrics}" />
              <img v-else src="/static/player/img_playmusic-grey.png" class="music-player__tune-image"/>
            </v-flex>
            <v-flex xs12 md6 class="music-player__tune-lyric" v-if="(isPcWindow && music.lyrics)|| (!isPcWindow && music.lyrics && isShowLyrics)">
              <p v-show="isPcWindow || (!isPcWindow && isShowLyrics)">{{ music.lyrics }}</p></v-flex>
          </v-layout>
          <v-layout row justify-center>
            <v-flex xs12 md12 class="music-player-information-downer">
              <div class="music-player-tune-title --down">
                <MarqueeMessage
                  ref="downMarqueeMessageTitle"
                  :message="music.title"
                  parent="player-down"/>
              </div>
              <div class="music-player-tune-artist">
                <MarqueeMessage
                  ref="downMarqueeMessageArtist"
                  :message="music.artist"
                  parent="player-down"/>
              </div>
              <FavoriteStarBtn class="music-player__star" :productId=parseInt(music.productId) />
            </v-flex>
          </v-layout>
          <div class="music-player__body_container">
            <v-layout row justify-center class="music-player__body">
              <v-layout row wrap justify-center class="music-player__controller">
                <v-flex xs2>
                  <RepeatBtn/>
                </v-flex>
                <v-flex xs2>
                  <PlayerPrevBtn/>
                </v-flex>
                <v-flex xs4>
                  <PlayPauseBtn/>
                </v-flex>
                <v-flex xs2>
                  <PlayerNextBtn/>
                </v-flex>
                <v-flex xs2>
                  <PlayerShuffleBtn/>
                </v-flex>
                <!--<MuteBtn/>-->
              </v-layout>
            </v-layout>
            <v-layout
              row
              wrap
              class="">
              <MusicTimeSlider/>
            </v-layout>
            <v-layout row wrap justify-end v-show="!isPcWindow">
              <v-flex xs2>
                <v-btn flat icon  class="player__library_books" :class="{'--active': music.lyrics}" @click="showLyric()">
                  <v-icon>library_books</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import RepeatBtn from '@/components/atoms/RepeatBtn'
import FavoriteStarBtn from '@/components/atoms/FavoriteStarBtn'
import MuteBtn from '@/components/atoms/MuteBtn'
import PlayPauseBtn from '@/components/atoms/PlayPauseBtn'
import FooterPlayerArtistImage from '@/components/atoms/FooterPLayerArtistImage'
import PlayerPrevBtn from './atoms/PlayerPrevBtn'
import PlayerNextBtn from './atoms/PlayerNextBtn'
import FooterPlayer from './Organisms/FooterPlayer'
import PlayerShuffleBtn from './atoms/PlayerShuffleBtn'
import MusicTimeSlider from './Organisms/MusicTimeSlider'
import MarqueeMessage from './atoms/MarqueeMessage'
export default {
  name: 'Player',
  components: {
    MarqueeMessage,
    MusicTimeSlider,
    PlayerShuffleBtn,
    FooterPlayer,
    PlayerNextBtn,
    PlayerPrevBtn,
    FooterPlayerArtistImage,
    PlayPauseBtn,
    MuteBtn,
    FavoriteStarBtn,
    RepeatBtn
  },
  data () {
    return {
      audio: undefined,
      mute: false,
      playerDialog: false,
      isRandom: false,
      isShowLyrics: false,
      isPcWindow: true
    }
  },
  mounted () {
    let audio = document.querySelector('#audio')
    let that = this
    audio.onended = function () {
      that.onEnd()
    }
    this.isPcWindow = window.parent.screen.width > 960
    window.addEventListener('resize', function () {
      that.isPcWindow = window.parent.screen.width > 960
    })
  },
  watch: {
    playerDialog (playerDialog) {
      if (!playerDialog) {
        this.isShowLyrics = false
      } else {
        this.$refs.upperMarqueeMessageTitle.setParam()
        this.$refs.upperMarqueeMessageArtist.setParam()
        this.$refs.downMarqueeMessageTitle.setParam()
        this.$refs.downMarqueeMessageArtist.setParam()
      }
    }
  },
  computed: {
    music () {
      return this.$store.getters['musicPlayerModuleGetNowPlayTuneData']
    }
  },
  methods: {
    showLyric () {
      if (window.parent.screen.width > 960) {
        this.isShowLyrics = true
      } else {
        if (this.music.lyrics) {
          this.isShowLyrics = !this.isShowLyrics
        } else {
          this.isShowLyrics = false
        }
      }
    },
    onEnd () {
      if (this.$store.getters.musicPlayerModuleIsLastTune && this.$store.getters.musicPlayerModuleIsNotRepeat) {
        // 最後の曲の場合プレイヤーを止める
        this.$store.dispatch('musicPlayerModuleSetNextPlayTuneData')
        this.$store.commit('musicPlayerModuleUpdateIsPlaying', false)
        return
      }
      if (!this.$store.getters['musicPlayerModuleIsOneRepeat']) {
        this.$store.dispatch('musicPlayerModuleSetNextPlayTuneData')
      }
      const audio = document.querySelector('#audio')
      const audioPlay = function () {
        audio.play()
      }
      setTimeout(audioPlay, 10)
    },
    muted: function () {
      this.$refs.waveSurferPlayer.toggleMute()
      this.audio.muted = true
      this.mute = true
    },
    mutedNone: function () {
      this.audio.muted = false
      this.mute = false
    },
    expandPlayer () {
      this.playerDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .player {
    margin: 5px;
    display: flex;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2),
    0 1px 1px 0 rgba(0, 0, 0, .14),
    0 1px 3px 0 rgba(0, 0, 0, .12);
  }

  button {
    cursor: pointer;
    outline: none;
  }
  button img {
    width: 14px;
    height: 14px;
  }

  .music-player {
    position: absolute;
    background: white;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    &:before {
      content: ' ';
      position: absolute;
      top: 0;
      /*background: hsla(0, 0%, 0%, 0.4);*/
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
  .music-player__tool-bar {
    flex: 0 0 auto;
    /*background: rgba(61, 197, 104, 0.6);*/
    z-index: 3;
  }
  .music-player__content {
    position: relative;
    margin: auto;
    padding: 1rem 0;
    width: 80%;
    z-index: 2;
    @media screen and (max-width: 960px){
      width: 100%;
      padding: 1rem;
    }
  }

  .music-player-information-upper {
    text-align: left;
    position: relative;
    @media screen and (max-width: 960px){
      display: none;
    }
    & > .flex {
      position: relative;
    }
    & /deep/ .music-player-information-upper__title-container{
      width: 24rem;
      margin-left: auto;
      margin-right: auto;
      position: relative;
    }
  }

  .music-player-information-downer {
    position: relative;
    height: 3rem;
    width: 24rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
    & > .music-player-tune-title,
    & > .music-player-tune-artist {
      @media screen and (min-width: 961px){
        display: none;
      }
    }
  }
  .music-player-tune-title {
    font-size: 1.25rem;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (max-width: 960px){
      padding-left: 4rem;
    }
    &.--down {
      width: calc(100% - 4rem);
    }
  }
  .music-player-tune-artist {
    opacity: .48;
    color: grey;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 4rem);
    @media screen and (max-width: 960px){
      padding-left: 4rem;
    }
  }
  .music-player__star{
    position: absolute;
    right: 0;
    top: 0;
    background: #fff;
    z-index: 2;
    width: 4rem !important;
  }
  .music-player__tune-media {
    margin-bottom: 2rem;
    @media screen and (max-width: 960px){
      margin-bottom: 0;
    }
  }

  .music-player__image-container {
    overflow: hidden;
    height: 24rem;
    @media screen and (max-width: 960px){
      height: 20rem;
      margin-bottom: 1vh;
    }
  }

  .music-player__tune-image {
    height: 24rem;
    width:  24rem;
    @media screen and (max-width: 960px){
      width: 20rem;
      height: 20rem;
    }
  }

  .music-player__tune-image.--blur{
    @media screen and (max-width: 960px){
      -webkit-filter: blur(5px);
      -webkit-transform: translate(0);
      -moz-filter: blur(5px);
      -moz-transform: translate(0);
      -o-filter: blur(5px);
      -o-transform: translate(0);
      -ms-filter: blur(5px);
      -ms-transform: translate(0);
      filter: blur(5px);
      top: -5rem;
      left: -5rem;
      right: -5rem;
      bottom: -5rem;
    }
  }

  .music-player__tune-lyric {
    line-height: 2.5rem;
    color: #000;
    font-weight: bold;
    overflow-y: scroll;
    padding-bottom: 6rem;
    white-space: pre-wrap;
    text-align: center;
    height: 24rem;
    width: 24rem;
    mask-image: -webkit-linear-gradient(90deg,transparent,#000,transparent) !important;
    @media screen and (max-width: 960px) {
      position: absolute;
      height: 20rem;
      width: 20rem;
      mask-image: none !important;
      color: #fff;
      background: rgba(10, 12, 10, 0.4);
    }
    &:before {
      content: "\A\A\A\A\A\A";
      white-space: pre;
    }
  }
  .music-player__controller /deep/ .btn{
    /*font-size: 10rem;*/
    /*height: 5rem;*/
    /*width: 5rem;*/
    z-index: 2;
  }
  .music-player__controller /deep/ .icon{
    color: #000;
    font-size: 3rem;
  }
  .music-player__time-bar {
    color: lightgray;
    font-weight: bold;
  }
  .--active /deep/ .icon{
    color: #15c06a!important;
  }
  .--notActive /deep/ .icon{
    color: #bdbdbd!important;
  }

  .footer-player__info {
    vertical-align: middle;
    padding: 1rem;
  }
  .footer-player__main-btn{
    display: flex;
  }
  .footer-player__sub-btn{
    display: flex;
    right: 1rem;
    position: absolute;
    @media screen and (max-width: 960px){
      display: none;
    }
  }
  .footer-playList__btn {
    background: #fff;
    z-index: 2;
    padding-top: 10px;
  }
  .footer-playList__controller-sm {
    display: flex;
  }
  .music-player__controller /deep/ .xs2{
    text-align: center;
  }
  .music-player__controller /deep/ .xs4{
    text-align: center;
  }
  .music-player__close-btn /deep/ .icon{
    color: grey;
  }
  /**
   * range
   */
  input[type=range] {-webkit-appearance:none;}
  input[type=range]::-webkit-slider-thumb{ -webkit-appearance:none;}
  input[type=range] {
    display: block;
  }
  input[type=range] {
    -webkit-appearance: none;
    margin: 0;
    width: 100%;
  }
  input[type=range]:focus {
    outline: none;
  }

  /* WebKit・Blink向け 溝のスタイル */
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: #cccccc;
    border-radius: 1.3px;
  }
  /* WebKit・Blink向け つまみのスタイル */
  input[type=range]::-webkit-slider-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -4px;
  }

  /* 何故か上の margin-top 指定が Edge に効いてしまうので、Edge向けに設定をリセット */
  @supports (-ms-ime-align: auto) {
    input[type=range]::-webkit-slider-thumb {
      margin-top: 0 !important;
    }
  }

  /* WebKit・Blink向け focus時のスタイル */
  input[type=range]:focus::-webkit-slider-runnable-track {
    background: #999999;
  }

  /* Firefox向け 溝のスタイル */
  input[type=range]::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    background: #cccccc;
    border-radius: 1.3px;
  }
  /* Firefox向け つまみのスタイル */
  input[type=range]::-moz-range-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
  }

  /* Edge・IE向け 溝のスタイル */
  input[type=range]::-ms-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }
  /* Edge・IE向け 溝の色（つまみより左側） */
  input[type=range]::-ms-fill-lower {
    background: #cccccc;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  /* Edge・IE向け 溝の色（つまみより右側） */
  input[type=range]::-ms-fill-upper {
    background: #cccccc;
    border-radius: 2.6px;
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  }
  /* Edge・IE向け つまみのスタイル */
  input[type=range]::-ms-thumb {
    box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
  }
  /* Edge・IE向け focus時の色（つまみより左側） */
  input[type=range]:focus::-ms-fill-lower {
    background: #999999;
  }
  /* Edge・IE向け focus時の色（つまみより右側） */
  input[type=range]:focus::-ms-fill-upper {
    background: #999999;
  }

  /* Edge・IE向け ポップアップを非表示に */
  input[type=range]::-ms-tooltip {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Player.vue